const data = {
  primaryColor: 'rgb(255, 170, 0)',
  secondaryColor: '#00305e'
}

export default data
